import React, { useContext, useEffect, useRef, useState } from 'react'
import { Button } from 'react-bootstrap';
import { BsBellFill } from 'react-icons/bs';
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { getNotificationListing, markAsReadNotification } from '../../api/context/notifications';
import Loader from '../../components/loader/loader';
import { SelectionContext } from '../../Context/Store';
import moment from 'moment';

const ViewNotifications = () => {
    const navigate = useNavigate();
    const myRef = useRef(null);

    const { notificationsAll, setNotificationsAll } = useContext(SelectionContext);
    const { updateCount, setUpdateCount } = useContext(SelectionContext);

    const [loading, setLoading] = useState(false);
    const [isswalnotification, setIsswalNotification] = useState(false);
    const [dataCount, setDataCount] = useState();
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 10;

    const getNotifications = (page, limit) => {
        setLoading(true);
        getNotificationListing({ page, limit })((response) => {
            if (response?.statusCode === 200) {
                setNotificationsAll(response?.data);
                setDataCount(response?.totalItems);
                setUpdateCount(response?.unreadCount);
            } else {
                console.error("Failed to fetch notifications");
            }
            setLoading(false);
        });
    };

    const handlePageChange = (selectedPage) => {
        getNotifications(selectedPage.selected + 1, itemsPerPage);
        setCurrentPage(selectedPage.selected);
        myRef.current?.scrollIntoView({ block: "start" });
    };

    const onClickmarkAsRead = (notification) => {
        const id = Number(notification?.typeId);

        // Mark as read and refresh the notification list
        markAsReadNotification(id)((response) => {
            if (response?.status) {
                getNotifications(currentPage + 1, itemsPerPage); // Fetch updated notifications for current page
            }
        });

        // Dynamic navigation with state
        switch (notification?.type) {
            case "order":
                navigate("/orderdetails/" + notification?.typeId, {
                    state: { notificationId: notification?.id },
                });
                break;
            case "chat":
                navigate("/chat-support", {
                    state: { chatId: notification?.typeId },
                });
                break;
            default:
                console.warn("No notification type");
        }
    };

    useEffect(() => {
        getNotifications(1, itemsPerPage);
    }, []);

    return (
        <div>
            <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h4 className="mb-sm-0">Notifications</h4>
                </div>
            </div>
            <div className="notification_view_all_wrapper">
                <div className="box bg-white mb-3" ref={myRef}>
                    <div className="box-body p-0">
                        {loading ? (
                            <div style={{ height: '60vh' }}>
                                <Loader />
                            </div>
                        ) : (
                            notificationsAll?.length > 0 ? (
                                notificationsAll.map((notification, index) => (
                                    <div
                                        key={index}
                                        className={`p-3 d-flex align-items-center cur-pointer border-bottom osahan-post-header position-relative ${notification?.status !== "read" ? "unread-notification" : "read-noti"}`}
                                        onClick={() => onClickmarkAsRead(notification)}
                                    >
                                        <div className="dropdown-list-image mr-3 position-relative">
                                            <BsBellFill
                                                size={40}
                                                className={notification?.status !== "read" ? "unread-icon" : "text-muted"}
                                            />
                                            {notification?.status !== "read" && (
                                                <span className="unread-badge position-absolute top-0 start-100 translate-middle p-1 bg-gradient border border-light rounded-circle"></span>
                                            )}
                                        </div>
                                        <div className="font-weight-bold mr-3 p-2">
                                            <div className={`text-truncate ${notification?.status !== "read" ? "fw-bold text-dark" : ""}`}>
                                                {notification.title}
                                            </div>
                                            <div className={`small ${notification?.status !== "read" ? "text-dark" : "text-muted"}`}>
                                                {notification.message}
                                            </div>
                                            <div className="text-muted small">
                                                {moment(notification?.createdAt).format("lll")}
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p className="no_data">No notifications found.</p>
                            )
                        )}
                    </div>
                </div>

                {notificationsAll?.length > 0 && Math.ceil(dataCount / itemsPerPage) > 1 && (
                    <ReactPaginate
                        pageCount={Math.ceil(dataCount / itemsPerPage)}
                        previousLabel={<MdOutlineKeyboardArrowLeft fontSize={24} color='#CECECE' />}
                        nextLabel={<MdOutlineKeyboardArrowRight fontSize={24} color='#CECECE' />}
                        onPageChange={handlePageChange}
                        containerClassName="pagination"
                        activeClassName="active"
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        disabledClassName="disabled"
                    />
                )}
            </div>
        </div>
    )
}

export default ViewNotifications;